var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-message response"},[_c('em',{staticClass:"icon-dot"}),_c('div',{staticClass:"text-message__txt",domProps:{"innerHTML":_vm._s(_vm.message.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }